// Order seems to affect how the CSS behaves. Let's ignore sorting in this file for now
import "@/sentry";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Route } from "react-router-dom";

// ----------------------------------------------------

import "../css/global.css";

import "@/translations";
import { ROUTES, INTERNAL_ROUTES } from "@/routes_new";
import { PublicAlertView, PublicTagView } from "@/views/PublicAlertView";
import ScrollToTop from "@components/ScrollToTop";
import { AudioPlayerContextProvider } from "@/contexts/GlobalAudioPlayerContext";
import I18nProvider from "@/containers/I18nProvider";
import TrackPageView from "@/containers/TrackPageView";
import AppRoot from "@/views/a";
import LocalizedPublicRoot from "@/views/[lang]";
import MessageProvider from "@/containers/Messages/MessageProvider";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import ActivationView from "@/views/ActivationView";
import LoginView from "@/views/LoginView";
import SignupView from "@/views/signup";
import ChannelDetailView from "@/views/internal/channel_details/ChannelDetailView";
import ChannelListView from "@/views/internal/channels/ChannelListView";
import InternalRoot from "@/views/internal/InternalRoot";
import { i18n } from "@lingui/core";
import { messages as en } from "@/locales/en/messages";
import { messages as sv } from "@/locales/sv/messages";
// import "media-chrome";
// import "media-chrome/media-theme-element";

i18n.load("en", en);
i18n.load("sv", sv);
i18n.activate("en");
const queryClient = new QueryClient();

const RootApp = () => (
  <MessageProvider>
    <BrowserRouter>
      <ScrollToTop />
      <AudioPlayerContextProvider>
        <I18nProvider>
          <Route path={ROUTES.LOGIN} component={LoginView} />
          <Route path={ROUTES.ACTIVATION} component={ActivationView} />
          <Route path={ROUTES.SIGNUP} component={SignupView} />
          <Route path={ROUTES.ALERT_PUBLIC}>
            <PublicAlertView />
          </Route>
          <Route path={ROUTES.TAG_PUBLIC}>
            <PublicTagView />
          </Route>

          <Route
            path={ROUTES.PUBLIC_LOCALIZED}
            component={LocalizedPublicRoot}
          />

          <Route path={ROUTES.APP_HOME} component={AppRoot} />
          <Route
            path={INTERNAL_ROUTES.CHANNEL_DETAIL}
            component={ChannelDetailView}
          />
          <Route
            exact
            path={INTERNAL_ROUTES.CHANNEL_LIST}
            component={ChannelListView}
          />
          <Route exact path={INTERNAL_ROUTES.BASE} component={InternalRoot} />
        </I18nProvider>
      </AudioPlayerContextProvider>
      <TrackPageView />
    </BrowserRouter>
  </MessageProvider>
);
const rootApp = document.getElementById("root-app");

if (rootApp) {
  const root = createRoot(rootApp);
  root.render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <RootApp />
      </QueryClientProvider>
    </StrictMode>
  );
}
